var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 67,
    width: 47,
    height: 16,
    rx: 2,
    fill: "#CA3C3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3301 79H56.8408V71.8613H60.9326V73.1016H58.3301V74.9424H60.752V76.1777H58.3301V79ZM63.3291 79V71.8613H64.8428V79H63.3291ZM67.6396 79V71.8613H69.1533V77.75H72.0488V79H67.6396ZM74.2939 79V71.8613H75.8076V77.75H78.7031V79H74.2939ZM85.0596 79H80.9482V71.8613H85.0596V73.1016H82.4619V74.6689H84.8789V75.9092H82.4619V77.75H85.0596V79ZM93.4766 75.3623C93.4766 76.5374 93.1413 77.4375 92.4707 78.0625C91.8034 78.6875 90.8382 79 89.5752 79H87.5537V71.8613H89.7949C90.9603 71.8613 91.8652 72.1689 92.5098 72.7842C93.1543 73.3994 93.4766 74.2588 93.4766 75.3623ZM91.9043 75.4014C91.9043 73.8682 91.2272 73.1016 89.873 73.1016H89.0674V77.75H89.7168C91.1751 77.75 91.9043 76.9671 91.9043 75.4014Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledLight);
export default __webpack_public_path__ + "static/media/filled-light.cb3224deb2940259183d61acf23c6ee3.svg";
export { ForwardRef as ReactComponent };